import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimesheetOpenFilterState = atom({
  key: "myTimesheetOpenFilterState",
  default: {
    contract: false,
    project: false,
    client: false,
    cost: false,
  },
  effects_UNSTABLE: [ocPersistAtom],
});

export default myTimesheetOpenFilterState;
